module.exports = __webpack_public_path__ + "static/img/dr-10.f253f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/products/dr-10.png
// module id = DxNR
// module chunks = 0